// extracted by mini-css-extract-plugin
module.exports = {"main":"ModalTransaction_main__2kR3t","link":"ModalTransaction_link__19rEM"};